import { ServiceSessionUserEvent } from '@modules/ServiceModule/workspace/types/ServiceEvents';
import { InboxContext } from '../types';
import { setExternalCallToAbandoned } from '../callHandlers/externalCalls';

function handleSessionRescinded(
  context: InboxContext,
  event: ServiceSessionUserEvent,
) {
  setExternalCallToAbandoned(context, event.sessionSid);
}

export default handleSessionRescinded;
